import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  blackColor,
  greyColor060,
  greyShade08,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  LineChart,
  Line,
  XAxis,
  AreaChart,
  Area,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
} from "recharts";

import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import OrderSaleTableSection from "./Sections/OrderSaleTableSection";
import ProductSellingSection from "./Sections/ProductSellingSection";
import SalesByAreaSection from "./Sections/SalesByAreaSection";
import { getTopSellingProductsData } from "../../reducers/orderReports/orderReportsSlice";
import { getStatsCountInfoData } from "../../reducers/businessDashboard/BusinessDashboardSlice";
import { addThousandsSeparator } from "../../utils/helper";
import moment from "moment";
import {
  getOrderReportAvgData,
  getOrderReportByCityData,
  getOrderReportByDaysData,
  getOrderReportByTypeYearData,
  getSaleAmtDataByYear,
  // getSaleAmtDataByYear,
  getTableSaleAmtDataByMonth,
} from "../../reducers/orderSummary/orderSummarySlice";
import SaleChartSection from "./Sections/SaleChartSection";
import OrderChartSection from "./Sections/OrderChartSection";
import SalesByYearChart from "./Sections/SalesByYearChart";
import TopCustomerSection from "./Sections/TopCustomerSection";
import { getDashboardOrderSummaryApi } from "../../service/api_calls/BusinessDashboard/BusinessDashboardApi";
import { getAllBusinessCustomersData } from "../../reducers/crmcustomerdata/customerSlice";
import TopOrdersByCityChartSection from "./Sections/TopOrdersByCityChartSection";
import OrderSaleByTypeYearSection from "./Sections/OrderSaleByTypeYearSection";
import OrderSaleAvgSection from "./Sections/OrderSaleAvgSection";
import SalesByDaysChart from "./Sections/SalesByDaysChart";
import EmptyCard from "../../components/Alerts/EmptyCard";

function OrderSummaryReportContent() {
  const [activeTab, setActiveTab] = useState("summary");

  const businessId = sessionStorage.getItem("selectedBusinessId");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { topSellingProducts, topSellingProductsLoader } = useSelector(
    (state) => state.orderReports
  );
  const {
    orderSaleAmtTableMonthData,
    orderSaleAmtTableMonthDataLoader,
    orderSaleAmtYearData,
    orderSaleAmtYearDataLoader,
    orderReportByCity,
    orderSalesByTypeYear,
    orderReportAvg,
    orderReportByDays,
  } = useSelector((state) => state.orderSummary);

  const {
    businessCustomers,
    businessCustomersPageNo,
    businessCustomersLoader,
  } = useSelector((state) => state.businessCustomers);

  const { statsCountInfo } = useSelector((state) => state.businessDashboard);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const businessUrl = sessionStorage.getItem("costboWEBURL");

    if (tab === "details") navigate(`/${businessUrl}/orderReports`);
    else if (tab === "summary") navigate(`/${businessUrl}/orderReportsSummary`);
  };

  function prepareDateRangePayload(selectedDateRange) {
    const today = moment();
    let fromDate, toDate;

    switch (selectedDateRange) {
      case "15 days":
        fromDate = moment().subtract(13, "days").startOf("day").valueOf();
        // fromDate = moment().subtract(1, "month").startOf("month");
        toDate = today.endOf("day");
        break;

      // case "30 days":
      //   fromDate = moment().subtract(1, "month").startOf("month");
      //   toDate = today.endOf("day");
      //   break;

      case "3 months":
        fromDate = moment().subtract(2, "months").startOf("month");
        toDate = today.endOf("month");
        break;

      case "6 months":
        fromDate = moment().subtract(5, "months").startOf("month");
        toDate = today.endOf("month");
        break;

      default:
        // Default to the entire current year if nothing is selected
        fromDate = moment().startOf("year");
        toDate = moment().endOf("year");
    }

    return {
      from: fromDate.valueOf(),
      to: toDate.valueOf(),
    };
  }

  const handleFilter = (values) => {
    console.log("search params", values);
    let payload = null;

    if (values?.type === "year") {
      payload = {
        businessId,
        params: {
          from: moment(`${values?.year}-01-01`).startOf("day").valueOf(),
          to: moment(`${values?.year}-12-31`).endOf("day").valueOf(),
          groupBy: "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: values?.type,
      };
    } else {
      payload = {
        businessId,
        params: {
          ...prepareDateRangePayload(values.dateRange),
          groupBy: values.dateRange === "15 days" ? "day" : "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: values?.type,
      };
    }
    dispatch(getTableSaleAmtDataByMonth(payload));
  };

  useEffect(() => {
    if (
      !statsCountInfo ||
      statsCountInfo?.orderCountInfo?.details?.totalOrders === 0
    )
      return;

    const currentYear = moment().year();
    dispatch(
      getTopSellingProductsData({
        businessId,
        params: {
          from: moment(`${currentYear}-01-01`).startOf("day").valueOf(),
          to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
          businessId: businessId,
        },
      })
    );
    dispatch(getOrderReportByCityData(businessId));
    dispatch(getOrderReportByTypeYearData(businessId));
    dispatch(getOrderReportAvgData(businessId));
    dispatch(
      getTableSaleAmtDataByMonth({
        businessId,
        params: {
          from: moment(`${currentYear}-01-01`).startOf("day").valueOf(),
          to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
          groupBy: "month",
          pageNo: "1",
          pageSize: "1",
        },
        type: "year",
      })
    );

    dispatch(
      getAllBusinessCustomersData({
        businessId,
        pageNo: 1,
      })
    );

    dispatch(
      getSaleAmtDataByYear({
        businessId,
        params: {
          from: moment(`2022-01-01`).startOf("day").valueOf(),
          to: moment(`${currentYear}-12-31`).endOf("day").valueOf(),
          groupBy: "year",
          pageNo: "1",
          pageSize: "1",
        },
      })
    );
    dispatch(
      getOrderReportByDaysData({
        businessId,
        params: {
          from: moment().subtract(5, "days").startOf("day").valueOf(),
          to: moment().endOf("day").valueOf(),
          groupBy: "day",
          pageNo: "1",
          pageSize: "1",
        },
      })
    );
  }, [statsCountInfo]);

  // useEffect(() => {
  //   if (!statsCountInfo) {
  //     dispatch(getStatsCountInfoData(businessId));
  //   }
  // }, []);

  return (
    <Box
      sx={{
        background: whiteColor,
        borderRadius: "12px",
        padding: "15px",
        mt: "20px",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box
          display="inline-flex"
          sx={{
            borderBottom: "0px solid #e7e8eb",
            borderRadius: "7px",
            background: "#f1f4f7",
            padding: "8px 12px",
            gap: 2,
          }}
        >
          <Button
            onClick={() => handleTabChange("summary")}
            sx={{
              height: "35px",
              color: activeTab === "summary" ? whiteColor : blackColor,
              background: activeTab === "summary" ? "#3f53d8" : "transparent",
              borderRadius: "5px",
              fontSize: "13px",
              fontWeight: 600,
              px: "15px",
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#3f53d8",
                color: whiteColor,
              },
            }}
          >
            Order Summary
          </Button>
          <Button
            onClick={() => handleTabChange("details")}
            sx={{
              height: "35px",
              px: "15px",
              color: blackColor,
              border: "none",
              background: "transparent",
              borderRadius: "5px",
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "capitalize",
              "&:hover": {
                backgroundColor: "#3f53d8",
                color: "#ffffff",
              },
            }}
          >
            Order Detail Analysis
          </Button>
        </Box>
        <Typography fontSize={12} color={greyShade08}>
          Order Summary starts from 1st Jan 2022
        </Typography>
      </Box>

      {statsCountInfo?.orderCountInfo?.details?.totalOrders === 0 && (
        <EmptyCard
          icon={"/./assets/image/order-cart-empty-1.svg"}
          iconWidth={"98px"}
          iconHeight={"85px"}
          message={"You are yet to receive your first order."}
          hideBtn
          paddingY={"30px"}
        />
      )}
      {statsCountInfo?.orderCountInfo?.details?.totalOrders > 0 && (
        <>
          <Grid container columnSpacing={4} mt={2} alignItems="stretch">
            <Grid item xs={3}>
              <Stack
                gap={"16px"}
                minHeight={"100%"}
                justifyContent={"space-between"}
              >
                <TotalOrderDetail
                  label={"Orders"}
                  value={
                    statsCountInfo?.orderCountInfo?.details?.totalOrders || 0
                  }
                  borderColor={`1px solid #ffdfed`}
                  bgColor={"#fff3f9"}
                  icon={
                    <ShoppingBasketOutlinedIcon
                      sx={{ fontSize: "26px", pr: 1 }}
                    />
                  }
                  iconColor={"#c94b85"}
                />
                <TotalOrderDetail
                  label={"Sales"}
                  value={`₹ ${addThousandsSeparator(
                    statsCountInfo?.orderCountInfo?.details?.totalAmount
                  )}`}
                  borderColor={`1px solid #d3f8de`}
                  bgColor={"#f1fff5"}
                  icon={
                    <AccountBalanceWalletOutlinedIcon
                      sx={{ fontSize: "26px", pr: 1 }}
                    />
                  }
                  iconColor={"#13ccac"}
                />
                <TotalOrderDetail
                  label={"Last Order Date"}
                  value={
                    statsCountInfo?.orderCountInfo?.details?.recentOrderSummary
                      ?.length > 0
                      ? moment(
                          statsCountInfo?.orderCountInfo?.details
                            ?.recentOrderSummary[0]?.orderDate
                        ).format("Do MMM YYYY")
                      : "N/A"
                  }
                  borderColor={`1px solid #e7daf5`}
                  bgColor={"#f9f3ff"}
                  icon={<CalendarMonthIcon sx={{ fontSize: "26px", pr: 1 }} />}
                  iconColor={"#894bc9"}
                />
              </Stack>
            </Grid>
            <Grid item xs={4.5}>
              <SalesByYearChart data={orderSaleAmtYearData} />
            </Grid>
            <Grid item xs={4.5}>
              <SalesByDaysChart data={orderReportByDays} />
            </Grid>
          </Grid>

          <OrderSaleTableSection
            data={orderSaleAmtTableMonthData || []}
            handleFilter={handleFilter}
            handleClearFilter={() =>
              handleFilter({ type: "year", year: moment().year() })
            }
          />

          <Grid container columnSpacing={2} mt={"20px"} alignItems="stretch">
            <Grid item xs={12} md={4}>
              <ProductSellingSection products={topSellingProducts} />
            </Grid>
            <Grid item xs={12} md={8}>
              <SalesByAreaSection orderReportByCity={orderReportByCity} />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={"4px"} alignItems="stretch">
            <Grid item xs={12} md={8}>
              <TopCustomerSection businessCustomers={businessCustomers} />
            </Grid>
            <Grid item xs={12} md={4}>
              <OrderSaleAvgSection orderReportAvg={orderReportAvg} />
            </Grid>
            <Grid item xs={12} md={4.5}>
              <OrderSaleByTypeYearSection
                orderSalesByType={orderSalesByTypeYear}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
}

export default OrderSummaryReportContent;

function TotalOrderDetail({
  label,
  value,
  hideLabel,
  borderColor,
  bgColor,
  icon,
  iconColor,
}) {
  return (
    <Box
      sx={{
        background: bgColor,
        border: borderColor,
        width: "100%",
        display: "flex",
        alignItems: "center",
        padding: "10px 12px",
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          width: "35px",
          height: "35px",
          position: "relative",
          color: "#ffffff",
          background: iconColor,
          border: "1px solid #fff",
          borderRadius: "8px",
          lineHeight: "27px",
          padding: "3px 8px",
          textAlign: "center",
          marginRight: "10px",
        }}
      >
        {icon}
      </Box>
      <Box>
        {!hideLabel ? (
          <Typography
            variant="h3"
            fontSize={{ xs: 12, md: 12 }}
            color={greyColor060}
            fontWeight={400}
            lineHeight={1.5}
          >
            {label}{" "}
          </Typography>
        ) : (
          <Box sx={{ height: "22px" }} />
        )}

        <Typography
          variant="body1"
          fontSize={{ xs: 12.5, md: 14 }}
          color={blackColor}
          fontWeight={600}
        >
          {value}
        </Typography>
      </Box>
      {/* <Box
        component="img"
        maxHeight={{ xs: "29px", md: "40px" }}
        src={}
        alt="CostBo"
      /> */}
    </Box>
  );
}
